// siret/getters
export const getters = {
  companie: (state) => {
    return state.companie;
  },
};
